import { setCookie } from "./util";
import { WPCPX_COOKIE, COOKIES_MAP } from "../constans";

export default function buildWPcpx(consent) {
    const data = +consent;

    setCookie(WPCPX_COOKIE, data, COOKIES_MAP.wpcpx.duration);
}
